(function () {
    "use strict";
    angular.module('swif.interventions')
        .config(router);

    function router($routeProvider) {
        'ngInject';
        $routeProvider.when('/interventions/interventions/gantt_view', {
            templateUrl: 'partials/openstc/interventions_gantt_view.html',
            controller: 'OpenSTCGanttController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifInterventionsService', function (service) {
                    // set default filter and create tasks and interventions collections
                    return service.gantt.resolveData();
                }]
            }
        });
    }

    angular.module('swif.interventions').controller('OpenSTCGanttController', OpenSTCGanttController);

    function OpenSTCGanttController($scope, swif, data, openstc) {
        'ngInject';
        var defaultMonthRange = 2;
        var defaultFrom = moment().startOf('week');
        var dayscaleMaxMonthRange = 2;

        // scope attributes

        $scope.loading = true;
        $scope.initializing = true;
        $scope.interventions = data.interventions;
        $scope.monthRange = defaultMonthRange;
        $scope.ganttOptions = {
            header: '<span translate>Intervention</span> / <span translate>Task</span>',
            currentDateValue: moment().startOf('day'),
            viewScale: 'day', //second, minute, hour, day, week, month, quarter, yea
            leftHeaderRowContent: `
<interventions-gantt-header-intervention 
      ng-if="row.model.type == 'intervention'"
      model="row.model"
      ></interventions-gantt-header-intervention>
<interventions-gantt-header-task 
      ng-if="row.model.type == 'task'"
      model="row.model"
      ></interventions-gantt-header-task>`,
            taskContent: `
<interventions-gantt-task 
  data="row.model.data"
  ></interventions-gantt-task>`
        };

        // scope methods

        $scope.setMonthRange = setMonthRange;
        $scope.shiftMonth = shiftMonth;
        $scope.moveToDefaultDate = moveToDefaultDate;
        $scope.moveToDate = moveToDate;
        $scope.expandAll = function () {
            _.forEach($scope.ganttData, function (item) {
                // expandAll / collapseAll api methods doesn't work
                if (item.type == 'intervention') {
                    $scope.ganttApi.tree.expand(item.id)
                }
            })
        };
        $scope.collapseAll = function () {
            _.forEach($scope.ganttData, function (item) {
                if (item.type == 'intervention') {
                    $scope.ganttApi.tree.collapse(item.id)
                }
            })
        };
        $scope.displayedFromDate = function () {
            return moment($scope.ganttOptions.fromDate).format('ll');
        };
        $scope.displayedToDate = function () {
            return moment($scope.ganttOptions.toDate).format('ll');
        };
        $scope.registerApi = function (api) {
            api.core.on.ready($scope, function () {
                $scope.ganttApi = api.gantt.api;
            });
            api.data.on.change($scope, function () {
                $scope.loading = false;
                $scope.initializing = false;
            });
        };

        // interventions add callbacks
        $scope.preModalIntervention = openstc.planning.preModalIntervention;
        $scope.preValidateIntervention = openstc.intervention.preValidate;
        $scope.callbackIntervention = function (error, data) {
            openstc.planning.callbackIntervention(error, data);
            // TODO: search / focus on new intervention after add
            refreshInterventions();
        };
        $scope.refreshInterventions = refreshInterventions;
        $scope.moveToDate = moveToDate;

        // initial state

        moveToDefaultDate();

        // helpers

        /* Set range of monthes to display on GANTT */
        function setMonthRange(value) {
            $scope.monthRange = value;
            if (value !== $scope.ganttOptions) {
                var ganttOptions = $scope.ganttOptions;
                ganttOptions.toDate = moment(ganttOptions.fromDate).add(value, 'months').startOf('week');
                if (value <= dayscaleMaxMonthRange) {
                    ganttOptions.viewScale = 'day';
                } else {
                    ganttOptions.viewScale = 'week';
                }
                $scope.ganttOptions = ganttOptions;
            }
        }

        /* shift range of monthes to display */
        function shiftMonth(value) {
            if (value !== 0) {
                var ganttOptions = $scope.ganttOptions;
                ganttOptions.fromDate = moment(ganttOptions.fromDate).add(value, 'months');
                ganttOptions.toDate = moment(ganttOptions.fromDate).add($scope.monthRange, 'months').startOf('week');
                $scope.ganttOptions = ganttOptions;
            }
        }

        function moveToDate(dateString) {
            var ganttOptions = $scope.ganttOptions;
            var fromDateString = moment(dateString).subtract(1, 'week');

            ganttOptions.fromDate = fromDateString;
            ganttOptions.toDate = moment(fromDateString).add($scope.monthRange, 'months').startOf('week');
        }

        function moveToDefaultDate() {
            moveToDate(defaultFrom);
        }

        /*
         * GANTT refresh pipeline
         *
         */

        // we refresh interventions collection
        function refreshInterventions() {
            // TODO: try to refresh only modified intervention using refreshCurrent ?
            $scope.loading = true;
            openstc.gantt.updateInterventions($scope.interventions.currentFilter)
                .then(function (interventionsCollection) {
                    $scope.interventions = interventionsCollection;
                });
        }

        // then we call for tasks refresh

        $scope.$watch('interventions.items', function (newV) {
            if (newV)
                $scope.loading = true;
                openstc.gantt.createTasks($scope.interventions).then(reloadGanttData);
        });

        // we load tasks

        // then we compute gantt data

        function reloadGanttData() {
            if (!$scope.interventions.items.length) {
                $scope.ganttData = [];
                return;
            }
            var tasks = openstc.gantt.getTasksCollection().items;
            var ganttData = [];
            var interventionsIds = [];     // ordered ids of interventions
            var interventionsById = {};    // temporary storage for interventions
            var tasksOfIntervention = {};  // mapping of intervention children tasks
            var tasksInfoById = {};

            /* add intervention rows */
            _.forEach($scope.interventions.items, function (intervention) {
                interventionsIds.push(intervention.id);
                tasksOfIntervention[intervention.id] = [];
                interventionsById[intervention.id] = {
                    type: 'intervention',
                    name: intervention.name,
                    children: [],
                    data: intervention,
                    height: '4em',
                    info: {
                        'date_start': undefined,
                        'date_end': undefined
                    },
                };
            });

            /* add tasks as intervention group children */
            _.forEach(tasks, function (task) {
                var stateInfo = swif.state.getStateInfo(task.state, task);
                tasksInfoById[task.id] = {
                    name: task.name,
                    from: task.date_start,
                    to: task.date_end,
                    priority: task.priority,
                    color: stateInfo.stateSetting.color,
                    data: task,
                };
                var interventionId = task.project_id[0];
                var intervention = interventionsById[interventionId];

                /* compute intervention start and end date */
                if (task.date_start !== undefined &&
                    (intervention.info.date_start === undefined || moment(intervention.info.date_start).isAfter(task.date_start))) {
                    intervention.info.date_start = task.date_start;
                }
                if (task.date_end !== undefined &&
                    (intervention.info.date_end === undefined || moment(intervention.info.date_end).isBefore(task.date_end))) {
                    intervention.info.date_end = task.date_end;
                }
                intervention.children.push(task.id);
                tasksOfIntervention[interventionId].push(task.id);
            });

            /* add task rows */
            _.forEach(interventionsIds, function (interventionId) {
                ganttData.push(interventionsById[interventionId]);
                _.forEach(tasksOfIntervention[interventionId], function (taskId) {
                    var taskInfo = tasksInfoById[taskId];
                    var taskModel = {
                        type: 'task',
                        id: taskId,
                        name: taskInfo.name,
                        tasks: [taskInfo],
                        data: taskInfo.data,
                        height: '4em'
                    };
                    ganttData.push(taskModel);
                });
            });

            $scope.ganttData = ganttData;
        }
    }

    // Template directives

    // Directive for row headers (tasks and interventions)

    // TODO or not TODO: use the same template for the two directives with a common interface
    angular.module('swif.interventions').directive('interventionsGanttHeaderTask', ganttHeaderTask);
    function ganttHeaderTask(openstc) {
        'ngInject';
        return {
            restrict: 'E',
            templateUrl: 'partials/openstc/interventions_gantt_header_task.html',
            scope: {
                model: '=',
            },
            link: function ($scope) {
                $scope.$watch('model.data', function (newV) {
                    if (newV) updateFormatedDates();
                });

                $scope.callback = function (error, data) {
                    openstc.planning.callbackTask(error, data);
                    $scope.$parent.scope.refreshInterventions();
                };
                $scope.moveToDate = function () {
                    $scope.$parent.scope.moveToDate($scope.model.data.date_start);
                };
                $scope.preValidate = openstc.planning.preValidateTask;
                $scope.preModal = openstc.planning.preModalTask;

                function updateFormatedDates() {
                    $scope.formatedFrom = ($scope.model.data.date_start ? moment($scope.model.data.date_start).format('l') : '');
                    $scope.formatedTo = ($scope.model.data.date_end ? moment($scope.model.data.date_end).format('l') : '');
                }
            }
        };
    }

    angular.module('swif.interventions').directive('interventionsGanttHeaderIntervention', ganttHeaderIntervention);
    function ganttHeaderIntervention(openstc) {
        'ngInject';
        return {
            restrict: 'E',
            templateUrl: 'partials/openstc/interventions_gantt_header_intervention.html',
            scope: {
                model: '=',
            },
            link: function ($scope) {
                $scope.$watch('model.info', function (newV) {
                    if (newV) updateFormatedDates();
                });

                $scope.moveToDate = function () {
                    $scope.$parent.scope.moveToDate($scope.model.info.date_start);
                };
                $scope.callback = function (error, data) {
                    openstc.planning.callbackIntervention(error, data);
                    $scope.$parent.scope.refreshInterventions();
                };
                $scope.preValidate = openstc.intervention.preValidate;
                $scope.preModal = openstc.planning.preModalIntervention;

                $scope.callbackAddTask = function (error, data) {
                    openstc.planning.callbackTask(error, data);
                    $scope.$parent.scope.refreshInterventions();
                };
                $scope.preValidateAddTask = openstc.planning.preValidateTask;
                $scope.preModalAddTask = openstc.planning.preModalTask;

                function updateFormatedDates() {
                    $scope.formatedFrom = ($scope.model.info.date_start ? moment($scope.model.info.date_start).format('l') : '');
                    $scope.formatedTo = ($scope.model.info.date_end ? moment($scope.model.info.date_end).format('l') : '');
                }
            }
        };
    }

    // Directive for task element modal

    angular.module('swif.interventions').directive('interventionsGanttTask', ganttTask);
    function ganttTask(openstc, swif, $uibModal) {
        'ngInject';
        return {
            restrict: 'E',
            template: `<span class="gantt-clickable-task" ng-click="taskClick(data)"></span>`,
            scope: {
                data: '=',
            },
            link: function ($scope) {
                $scope.taskClick = taskClick;
                $scope.callback = function (error, data) {
                    openstc.planning.callbackTask(error, data);
                    $scope.$parent.scope.refreshInterventions();
                };
                $scope.preValidate = openstc.planning.preValidateTask;
                $scope.preModal = openstc.planning.preModalTask;

                function taskClick(data) {
                    var filter = {};
                    filter.fields = openstc.task.COLLECTION_FIELDS;
                    swif.data.get('task', data.id, filter)
                        .then(function (task) {
                            var modalInstance = $uibModal.open({
                                templateUrl: 'partials/openstc/planning_event_modal.html',
                                controller: 'PlanningEventModal',
                                resolve: {
                                    modalParams: function () {
                                        return {task: task};
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $scope.$parent.scope.refreshInterventions();
                            });
                        });
                }
            }
        };
    }
})();
